import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";
import PropTypes from "prop-types";

function WhoIcon(props) {
  const { pathProps, ...other } = props;
  return (
    <SvgIcon {...other}>
      <div>
        Icons made by{" "}
        <a
          href="https://www.flaticon.com/authors/icongeek26"
          title="Icongeek26"
        >
          Icongeek26
        </a>{" "}
        from{" "}
        <a href="https://www.flaticon.com/" title="Flaticon">
          www.flaticon.com
        </a>
      </div>
      <polygon
        points="76 380.517 73.111 377.628 76 376.839 76 380.517"
        {...pathProps}
      />
      <polygon
        points="132 380.459 132 376.922 134.778 377.681 132 380.459"
        {...pathProps}
      />
      <polygon
        points="98 432.534 98 428.361 96.381 429.444 98 432.534"
        {...pathProps}
      />
      <line x1="86.022" y1="421.969" x2="70.226" y2="391.795" />
      <circle cx="120.446" cy="469.852" r="7.351" {...pathProps} />
      <circle cx="120.446" cy="450.153" r="7.351" {...pathProps} />
      <path
        d="M487.933,20H117.747C108.925,20,102,27.546,102,36.368V67.506C102,76.329,108.925,84,117.747,84H122V187h12V84H471V299.812c0,14-10.779,25.188-23.951,25.188H160v12H289.965l-53.96,58.136A6.051,6.051,0,0,0,240.4,405.3a5.969,5.969,0,0,0,4.4-1.9l57.8-62.16,57.8,62.169a6,6,0,0,0,8.48.311,6.12,6.12,0,0,0,.309-8.578L315.218,337H447.049C466.838,337,483,320.426,483,299.812V84h4.933C496.756,84,504,76.329,504,67.506V36.368A16.394,16.394,0,0,0,487.933,20ZM492,67a4,4,0,0,1-4,4H118a4,4,0,0,1-4-4V36a4,4,0,0,1,4-4H488a4,4,0,0,1,4,4Z"
        {...pathProps}
      />
      <path
        d="M265,210a6,6,0,0,0-6-6H235a6,6,0,0,0-6,6v60a6,6,0,0,0,6,6h24a6,6,0,0,0,6-6Zm-24,6h12v48H241Z"
        {...pathProps}
      />
      <path
        d="M321,190a6,6,0,0,0-6-6H291a6,6,0,0,0-6,6v80a6,6,0,0,0,6,6h24a6,6,0,0,0,6-6Zm-24,6h12v68H297Z"
        {...pathProps}
      />
      <path
        d="M377,150a6,6,0,0,0-6-6H347a6,6,0,0,0-6,6V270a6,6,0,0,0,6,6h24a6,6,0,0,0,6-6Zm-24,6h12V264H353Z"
        {...pathProps}
      />
      <path
        d="M200,485.632V429.4c0-.167.026-.333.013-.5a41.361,41.361,0,0,0-22.58-33.375c-.21-.1-.217-.2-.438-.277l-24-8.734v-11.9a6.191,6.191,0,0,0-3.9-5.544,7.671,7.671,0,0,0-.817-.236l-.048-.008-15.708-4.286a71.991,71.991,0,0,0,43.126-61.53,22.789,22.789,0,0,0,13.295-26.434,18.44,18.44,0,0,0-10.428-12.567l.849-5.932c.021-.145.036-.291.046-.438a75.572,75.572,0,0,0-94.985-78.31,83.155,83.155,0,0,0-14.934,6.076q-1.227.6-2.464,1.192a6,6,0,0,0-3.409,5.412,15.166,15.166,0,0,1-6.786,12.659l-18.8,12.494a5.992,5.992,0,0,0-1.833,1.926l-1.117,1.874a5.982,5.982,0,0,0-.322.621,75.821,75.821,0,0,0-6.371,36.057c.01.151.026.3.048.454l.861,5.886a18.436,18.436,0,0,0-10.487,12.6,22.776,22.776,0,0,0,10.1,24.768,20.817,20.817,0,0,0,3.23,1.478,72,72,0,0,0,43.19,61.733l-15.384,4.2.02.07a3.283,3.283,0,0,0-.5.241A5.8,5.8,0,0,0,56,374.618v11.9L31.563,395.25c-.22.08-.553.172-.763.277A41.476,41.476,0,0,0,8.112,428.9c-.014.166-.112.332-.112.5v56.231A6.383,6.383,0,0,0,14.067,492h180C197.38,492,200,488.945,200,485.632Zm-96.029-76.967L88,392.517V368.69a69.274,69.274,0,0,0,15.806,1.811A68.523,68.523,0,0,0,120,368.6v23.856ZM76,380.517l-2.889-2.889L76,376.839Zm18.649,35.7-8.627,5.751L70.226,391.8ZM137.907,391.8l-15.8,30.174-8.626-5.751ZM132,380.459v-3.537l2.778.759ZM63.475,214.666a27.132,27.132,0,0,0,11.866-18.758,69.6,69.6,0,0,1,12.2-4.986A63.651,63.651,0,0,1,167.454,256.6l-1.262,8.812-.658.814a.415.415,0,0,1-.557.157c-.335-.118-.335-.063-.335-.237A26.214,26.214,0,0,0,138.258,240H98.808a5.318,5.318,0,0,1-5.105-5.341,18.078,18.078,0,0,0-17.741-18.035l-15.031-.208ZM44.024,298.525A6,6,0,0,0,38.96,292.6c-.991-.348-3.138-1.222-3.917-1.575a10.771,10.771,0,0,1-4.573-11.59,6.637,6.637,0,0,1,6.02-5.068,6,6,0,0,0,5.435-6.386l-.062-.9c-.011-.153-.027-.305-.049-.456L40.348,256.6a63.867,63.867,0,0,1,4.634-28.4l30.861.306a6.146,6.146,0,0,1,5.86,6.154A17.327,17.327,0,0,0,98.808,252h39.45a14.2,14.2,0,0,1,14.384,14.149,12.217,12.217,0,0,0,8.335,11.669,12.36,12.36,0,0,0,12.731-2.732,6.353,6.353,0,0,1,3.577,4.377,10.784,10.784,0,0,1-8.447,13.155,5.893,5.893,0,0,0-4.838,5.9v.106a59.988,59.988,0,0,1-119.976-.1ZM20,429.662a29.571,29.571,0,0,1,15.718-23.25l24.057-8.675,18.7,35.707a6.01,6.01,0,0,0,5.321,3.217,5.89,5.89,0,0,0,3.3-1.008L98,428.361V480H20ZM188,480H110V428.361l10.972,7.292a6.027,6.027,0,0,0,8.673-2.209l18.694-35.707,24.009,8.675A29.5,29.5,0,0,1,188,429.662Z"
        {...pathProps}
      />
    </SvgIcon>
  );
}

WhoIcon.propTypes = {
  children: PropTypes.node,
  pathProps: PropTypes.object
};

export default WhoIcon;
